import url from 'url';
import h from 'react-hyperscript';

import './Header.css';

/* istanbul ignore next */
const { REACT_APP_ENV_PREFIX = '' } = process.env;
let PREFIX = '';

/* istanbul ignore next */
if (REACT_APP_ENV_PREFIX) {
  PREFIX = `${REACT_APP_ENV_PREFIX.toLowerCase()}-`;
}

const loginUrlObj = {
  protocol: /* istanbul ignore next */ REACT_APP_ENV_PREFIX.toLowerCase() === 'local' ? 'http' : 'https',
  host: `${PREFIX}app.npo.events`,
};

const Header = () =>
  h('header.header#header', [
    h('.container', [
      h('figure.logo.animated.fadeInDown.delay-07s', [
        h('img', { src: 'img/logo-scllc-dark.png', alt: 'Simple City Logo' }),
      ]),
      h('h1.animated.fadeInDown.delay-07s', 'Welcome to Simple City'),
      h('ul.we-create.animated.fadeInUp.delay-1s', [h('li', ['We make your events crazy simple.'])]),
      h(
        'a.link.animated.fadeInUp.delay-1s.servicelink.invert',
        {
          href: '#service',
        },
        'Our Services',
      ),
      h('div', [
        h('a.link.animated.fadeInUp.delay-1s.login', { href: url.format(loginUrlObj) }, [
          h('i.fa.fa-lock'),
          h('span', ' Log In'),
        ]),
      ]),
    ]),
  ]);

export default Header;



// WEBPACK FOOTER //
// ./src/components/Header/Header.js